module.exports = __webpack_public_path__ + "assets/img/67_525_3.8fc9bbd3.jpg";